import React from 'react';
import './WebsiteThumbnail.scss';

const WebsiteThumbnail = ({ theme, phone, footer, salesBanner }) => {


  const styles = {
    page: {
      backgroundColor: theme.colors.page.backgroundColor,
    },
    header: {
      backgroundColor: theme.colors.header.background,
    },
    menuButton: {
      backgroundColor: theme.buttons.action.backgroundColor,
      color: theme.buttons.action.color,
    },
    loginButton: {
      backgroundColor: theme.colors.header.button.backgroundColor,
      color: theme.colors.header.button.color,
    },
    helpButton: {
      backgroundColor: theme.colors.header.button.alt.backgroundColor,
      color: theme.colors.header.button.alt.color,
    },
    telephone: {
      color: theme.colors.header.phoneUs.color,
    },
    spanBefore: {
      borderLeft: '16px solid ' + theme.colors.page.backgroundColor,
    },
    breadcrumbVisited: {
      backgroundColor: theme.colors.breadcrumb.enabled.backgroundColor,
      color: theme.colors.breadcrumb.enabled.color,
    },
    spanVisited: {
      borderLeft: '14px solid ' + theme.colors.breadcrumb.enabled.backgroundColor,
    },
    breadcrumbActive: {
      backgroundColor: theme.colors.breadcrumb.active.backgroundColor,
      color: theme.colors.breadcrumb.active.color,
    },
    spanActive: {
      borderLeft: '14px solid ' + theme.colors.breadcrumb.active.backgroundColor,
    },
    breadcrumbDisabled: {
      backgroundColor: theme.colors.breadcrumb.backgroundColor,
      color: theme.colors.breadcrumb.color,
    },
    spanDisabled: {
      borderLeft: '14px solid ' + theme.colors.breadcrumb.backgroundColor,
    },
    quoteContainer: {
      backgroundColor: theme.colors.box.primary.backgroundColor,
      color: theme.colors.box.primary.color,
    },
    quoteContainerBox: {
      backgroundColor: theme.colors.box.totalPayable.backgroundColor,
      color: theme.colors.box.totalPayable.colorAlt,
    },
    sectionHeading: {
      color: theme.colors.box.primary.color,
    },
    quoteHeader: {
      color: theme.colors.box.primary.color,
    },
    infoButton: {
      color: theme.buttons.action.backgroundColor,
    },
    optionButtonActive: {
      backgroundColor: theme.colors.button.group.ampHover.backgroundColor,
      borderColor: theme.colors.button.group.borderColor,
      color: theme.colors.button.group.color,
    },
    optionButton: {
      backgroundColor: theme.colors.button.group.backgroundColor,
      color: theme.colors.button.group.color,
      borderColor: theme.colors.button.group.borderColor,
    },
    divider: {
      borderTop: '1px solid',
      // borderColor: theme.colors.generatedPdf.divider.color,
      borderColor: theme.colors.box.totalPayable.borderColor,
      padding: '3px 0'
    },
    backButton: {
      backgroundColor: theme.colors.button.action.alt.backgroundColor,
      color: theme.colors.button.action.color,
    },
    nextButton: {
      backgroundColor: theme.colors.button.action.backgroundColor,
      color: theme.colors.button.action.color,
    },
    footer: {
      backgroundColor: theme.colors.footer.backgroundColor,
      color: theme.colors.footer.color,
    },
  };

  const breadcrumbText = [
    {
      text: 'Trip Details',
      visited: true
    },
    {
      text: 'Medical Declaration',
      visited: true
    },
    {
      text: 'Additional Cover',
      visited: true
    },
    {
      text: 'Cover Choices',
      visited: false
    },
    {
      text: 'Your Cover',
      visited: false
    },
    {
      text: 'About you',
      visited: false
    },
    {
      text: 'Payment',
      visited: false
    },
    {
      text: 'Policy Complete',
      visited: false
    },
  ];

  return (
    <div className="whitelabel-preview">
      <div className="wl-thumbnail-container">
        <label>B2C Website</label>
        <div className="wl-thumbnail" style={styles.page}>
          <div className="wl-header" style={styles.header}>
            <div className="wl-left-hand-container">
              <div className="wl-button faqs" style={styles.helpButton} />
              <div className="wl-button contact-us" />
            </div>
            <div className="wl-right-hand-container">
              <div className="wl-headings">
                <span className="telephone" style={styles.telephone}>
                  {phone || '0800 0000 0000'}
                </span>
                <span className="hours">Open 9-5</span>
              </div>
              <div className="wl-button login" style={styles.loginButton} />
            </div>
            <div className="wl-logo-container">
              <img alt="logo" className="wl-logo" src={theme.urls.logo} />
            </div>
          </div>
          {salesBanner && salesBanner.enabled && salesBanner.sections && <div className="wl-campaign-banner text-center">
              <p>
                {salesBanner.sections.header_content}
                <br />
                {salesBanner.sections.sub_header_content}
                <br />
                <span>{salesBanner.sections.small_print}</span>
              </p>
            </div>}
          <div className="wl-breadcrumb">
            <ul>
              {breadcrumbText.map((breadcrumb) => {
                return (
                  <li className={breadcrumb.visited ? 'visited' : ''}>
                    {breadcrumb.text}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="wl-quote-container" style={styles.quoteContainer}>
            <p className="wl-quote-header" style={styles.quoteHeader}>
              Additional Cover
            </p>
            <p className="wl-quote-text">
              Please ensure that you have any additional cover you require by adding the appropriate cover extensions below..
              <br />
              Please click on the <i className="fa fa-info-circle" style={styles.infoButton} /> next to each extension for details of the cover.
            </p>
            <div className="wl-quote-box" style={styles.quoteContainerBox}>
              <p className="wl-quote-section-header" style={styles.sectionHeading}>
                Additional Activities
              </p>
              <div className="wl-option-button-container">
                <div className="wl-option-button-wrapper left">
                  <div className="wl-option-button" style={styles.optionButtonActive}>
                    <span>Category A</span>
                  </div>
                  <div className="wl-option-button-info">
                    <i className="fa fa-info-circle" style={styles.infoButton} />
                  </div>
                </div>
                <div className="wl-option-button-wrapper right">
                  <div className="wl-option-button" style={styles.optionButton}>
                    <span>Category B</span>
                  </div>
                  <div className="wl-option-button-info">
                    <i className="fa fa-info-circle" style={styles.infoButton} />
                  </div>
                </div>
              </div>
            </div>

            <div className="wl-button-bar">
              <div style={styles.divider} />
              <div className="wl-button pull-left" style={styles.backButton}>
                Back
              </div>
              <div className="wl-button pull-right" style={styles.nextButton}>
                Next >
              </div>
            </div>
          </div>
          <div className="wl-footer" style={styles.footer}>
            <p>
              {footer ||
                'Just Insurance Agents Limited. Registered in England. Company No. 05399196\n\n' +
                  'Registered Office: Victoria House, Toward Road, Sunderland, SR1 2QF\n' +
                  'Just Insurance Agents Limited are authorised and regulated by the\n' +
                  'Financial Conduct Authority (FCA) number 610022.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );

};
export default WebsiteThumbnail;
